module.exports = __webpack_public_path__ + "static/media/icing-gray.a37b6c5d.png";